type Props = {
  value: number|string
}

const GCurrency = ({ value } : Props) => {
  const val = !value || Number.isNaN(value) ? '-'
    : new Intl.NumberFormat('es-ES',
      {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 2
      }).format(value as any)

  return <>{value > 50 ? val.replace(/\D00(?=\D*$)/, '') : val}</>
}

export default GCurrency
